import React from "react";
import { FaTimes } from "react-icons/fa";
import { useWindowContext } from "../Context/WindowContext";

const FooterTabs = () => {
  const { windows, activeWindowId, setActiveWindow, closeWindow, restoreWindow } = useWindowContext();

  if (!windows.length) return null;

  const handleTabClick = (windowItem) => {
    if (windowItem.minimized) {
      restoreWindow(windowItem.id);
    } else {
      setActiveWindow(windowItem.id);
    }
  };

  return (
    <footer className="Footer-Tabs">
      <div className="Footer-Tabs-Container">
        {windows.map((window) => (
          <button
            key={window.id}
            type="button"
            className={`content-tab footer-tab ${activeWindowId === window.id ? "active" : ""} ${window.minimized ? "minimized" : ""}`}
            onClick={() => handleTabClick(window)}
          >
            <span className="content-tab-icon footer-tab-icon">{window.icon}</span>
            <span className="content-tab-title footer-tab-title">{window.title}</span>
            <span
              className="content-tab-close footer-tab-close"
              onClick={(event) => {
                event.stopPropagation();
                closeWindow(window.id);
              }}
            >
              <FaTimes />
            </span>
          </button>
        ))}
      </div>
    </footer>
  );
};

export default FooterTabs;